module.exports = __webpack_public_path__ + "static/banner-97feb9d6e20c6351c878435bffe8916b.jpg";